import {
  FormLabelInput,
  TitleInputContainer,
  TitleDescription,
  MessageInputContainer,
  FormLabel,
} from "@/components/ui/form-elements";
import EdsSearchableSelect from "../EdsSearchableSelect";
import NodeContext from "../../context/NodeContext";
import { useCallback, useContext } from "react";
import { LABELS } from "../../utils/labels";
import { useState } from "react";
import { useEffect } from "react";

function JumpToProfileEditor() {
  const { selectedNodeInfo, updateNode, nodes, isEditable, profiles, getProfileIdQuestions, profileQuestionOptions } =
    useContext(NodeContext);
  const [selectedOption, setSelectedOption] = useState(selectedNodeInfo?.data?.value === "0" ? null : {
    value: selectedNodeInfo?.data?.value,
    label: selectedNodeInfo?.data?.label,
  });

  const getProfileQuestions = useCallback(async (profileId) => {
    await getProfileIdQuestions(profileId);
  }, [getProfileIdQuestions]);

  const createOptions = useCallback(() => {
    const options = [];
    profiles.forEach((profile) => {
      options.push({
        value: profile.profileId,
        label: profile.profileName,
      });
    });
    return options;
  }, [profiles]);


  useEffect(() => {
    if (selectedNodeInfo?.data?.value !== "0") {
      getProfileQuestions(selectedNodeInfo?.data?.value);
    }
  }, [selectedNodeInfo?.data?.value, getProfileQuestions]);

  if (!selectedNodeInfo) {
    return null;
  }

  return (
    <>
      <TitleInputContainer>
        <FormLabelInput
          placeholder="Label"
          value={selectedNodeInfo?.data?.titleText}
          onChange={(e) => {
            updateNode(selectedNodeInfo.id, {
              ...selectedNodeInfo?.data,
              titleText: e.target.value,
            });
          }}
          readOnly={!isEditable}
        />
        <TitleDescription>
          Allows you to route the conversation flow from this point to the below mentioned profile.
        </TitleDescription>
      </TitleInputContainer>
      <MessageInputContainer>
        <FormLabel>{LABELS.GO_TO_PROFILE}</FormLabel>
        <EdsSearchableSelect
          options={createOptions().length > 0 ? createOptions() : [{ value: "no-options", label: "No options" }]}
          value={selectedNodeInfo?.data?.value === "0" ? null : selectedNodeInfo?.data?.value}
          onChange={(value) => {
            if (value === "no-options") return;
            const selectedOpt = createOptions().find((o) => String(o.value) === String(value));
            getProfileQuestions(value ? value : null);
            setSelectedOption(selectedOpt || null);
            updateNode(selectedNodeInfo.id, {
              ...selectedNodeInfo?.data,
              value: value || "0",
              label: selectedOpt ? selectedOpt.label : "Select a profile",
              questionId: "0",
              questionValue: "Select a question",
            });
          }}
          placeholder="Select a profile"
          isDisabled={!isEditable || createOptions().length === 0}
          isClearable={true}
          key={selectedNodeInfo?.id}
        />
      </MessageInputContainer>
      {(profileQuestionOptions.length > 0 || selectedOption) && <MessageInputContainer>
        <FormLabel>Select a question</FormLabel>
        <EdsSearchableSelect
          options={profileQuestionOptions.length > 0 ? profileQuestionOptions : [{ value: "no-options", label: "No options" }]}
          value={selectedNodeInfo?.data?.questionId === "0" ? null : selectedNodeInfo?.data?.questionId}
          onChange={(value) => {
            if (value === "no-options") return;
            const selectedQuestion = profileQuestionOptions.find((o) => String(o.value) === String(value));
            updateNode(selectedNodeInfo.id, {
              ...selectedNodeInfo?.data,
              questionId: value || "0",
              questionValue: selectedQuestion ? selectedQuestion.label : "Select a question",
            });
          }}
          placeholder="Select a question"
          isDisabled={profileQuestionOptions.length === 0}
          isClearable={true}
        />
      </MessageInputContainer>}
    </>
  );
}

export default JumpToProfileEditor;
